import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  background-color: #fff;\n  @media (max-width: 768px) {\n    display: flex;\n    margin: 0 -16px;\n    padding: 0;\n    gap: 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  background-color: ",
        ";\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 20px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));\n\n  @media (max-width: 768px) {\n    display: flex;\n    margin: 0 -16px;\n    padding: 0;\n    gap: 0;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SearchFilteredProductEmpty } from "@/components/Search/SearchFilteredProductEmpty";
import { SearchProductEmpty } from "@/components/Search/SearchProductEmpty";
import { SkeletonListItem } from "@/components/Search/SkeletonListItem";
import React from "react";
import styled from "styled-components";
import { SearchListItemView } from "./SearchListItemView";
export const SearchProductListView = (param)=>{
    let { list , isLoading , isFetchingNextPage , hasNextPage , emptyStatus  } = param;
    if (isLoading) return /*#__PURE__*/ _jsx(NewSearchListWrapper, {
        className: "mt-16",
        children: [
            ...Array(10)
        ].map((_, index)=>/*#__PURE__*/ _jsx(SkeletonListItem, {}, index))
    });
    if (emptyStatus === "FILTER") {
        return /*#__PURE__*/ _jsx(SearchFilteredProductEmpty, {});
    }
    if (emptyStatus === "ITEM") return /*#__PURE__*/ _jsx(SearchProductEmpty, {});
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(NewSearchListWrapper, {
                children: list.pages.map((page, idx)=>{
                    return /*#__PURE__*/ _jsx(React.Fragment, {
                        children: page === null || page === void 0 ? void 0 : page.data.map((product)=>{
                            if (!!!product) return null;
                            return /*#__PURE__*/ _jsx(SearchListItemView, {
                                product: product
                            }, product.productId);
                        })
                    }, "search-list-data-".concat(idx));
                })
            }),
            isFetchingNextPage && hasNextPage && /*#__PURE__*/ _jsx(NewSearchListWrapper, {
                children: [
                    ...Array(2)
                ].map((_, index)=>/*#__PURE__*/ _jsx(SkeletonListItem, {}, index))
            })
        ]
    });
};
//@fixme: 추후삭제 (알라딘 굿노트 사용중)
export const SearchListWrapper = styled.div.withConfig({
    componentId: "sc-24eecd73-0"
})(_templateObject());
export const NewSearchListWrapper = styled.div.withConfig({
    componentId: "sc-24eecd73-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_gray_0);
